// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { LookupDropDownDefaults } from '../../UtilsClasses/LookupDropDownDefaults';
import { AccountLookupDropDownFormViewModel } from '../../ViewModels/AccountLookupDropDownFormViewModel';
import React from 'react';
import { LookupDropDownForm } from './LookupDropDownForm';
import { Button } from './Button';
import { Checkbox } from '@components/webdesktop/elements/Checkbox/Checkbox';
import { FormLabel } from '@components/webdesktop/elements/FormLabel/FormLabel';
export class AccountLookupDropDownForm extends LookupDropDownForm {
    constructor(props) {
        super(props, AccountLookupDropDownFormViewModel);
        this.onCheckAllStateChange = (event) => {
            this.viewModel.onCheckAllStateChange(event.currentTarget.checked);
        };
        this.onAddBtnClick = this.onAddBtnClick.bind(this);
        this.onCancelBtnClick = this.onCancelBtnClick.bind(this);
    }
    onAddBtnClick() {
        this.viewModel.onAddBtnClicked(true);
    }
    onCancelBtnClick() {
        this.viewModel.close();
    }
    renderDropDownForm() {
        return (React.createElement("div", { className: "accountLookupDropDownForm" },
            React.createElement("div", { className: "header_acc_lookupDropDownForm" },
                this.renderTextBox('textBox_acc_lookupDropDownForm'),
                React.createElement("div", { className: "account-lookup-header-filter" }, this.renderMultiSelectCheckbox())),
            React.createElement("div", { className: "body_acc_lookupDropDownForm" }, this.renderQuickTree()),
            this.renderFooter()));
    }
    renderFooter() {
        if (!this.viewModel.isShowFooterBtn()) {
            return null;
        }
        const { selectAllText, checkedSelectedAll, enabledAddBtn, addBtnText, cancelBtnText } = this.state;
        return (React.createElement("div", { className: "footer_acc_lookupDropDownForm" },
            React.createElement("div", { className: "checkBoxContainer_acc_lookupDropDownForm" },
                React.createElement(FormLabel, { label: selectAllText },
                    React.createElement(Checkbox, { checked: checkedSelectedAll, onChange: this.onCheckAllStateChange }))),
            React.createElement("div", { className: "addCancelBtnContainer_acc_lookupDropDownForm" },
                React.createElement(Button, { text: addBtnText, buttonStyle: "js-button-ok style-width-100", enabled: enabledAddBtn, onClick: this.onAddBtnClick }),
                React.createElement(Button, { text: cancelBtnText, buttonStyle: "js-button-gray25 style-width-100", onClick: this.onCancelBtnClick }))));
    }
}
AccountLookupDropDownForm.defaultProps = {
    width: LookupDropDownDefaults.width,
    height: LookupDropDownDefaults.height
};
